import { PerformanceVenueInfoResponse, PerformanceVenueRequest } from 'src/common-services/types/performance-types'
import { BaseClient } from 'src/common-services/clients/base-client'

// useful for develping quickly, prefer named clients once code settles down
export class DevClient extends BaseClient {
  get<T>(url: string, params?: any): Promise<T> {
    return this.call(url, 'GET', { params })
  }
  post<T>(url: string, data: any): Promise<T> {
    return this.call(url, 'POST', { data })
  }
}

export class PerformanceClient extends BaseClient {
  getVenueInfo(request: PerformanceVenueRequest): Promise<PerformanceVenueInfoResponse> {
    return this.call<PerformanceVenueInfoResponse>(`/performance/venues/${encodeURIComponent(request.venueId)}`, 'GET')
  }
}
